module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/C7Ikxx/tc-custom/9781626810464.jpg?1728725936708",
      "alt": "This image is the cover for the book Hearts of Fire, The Fire Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hearts of Fire, The Fire Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The multigenerational medieval romance series continues with a novel of all-consuming passion from “a superlative writer!” ("), _c('i', [_vm._v("RT Book Reviews")]), _vm._v(")")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Gilliane de Lacey’s pride is as fiery as her hair. In the face of a command from the King of England himself, she refused to wed a lord she despises. The one man she does want, Richard of Rivaux, is honor-bound to wed another, even though his passion for her has become a burning need."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Defying death to rescue Gilliane from the royal wrath, Richard draws his love into the perilous swirl of conflict between England and Normandy. Against this dramatic backdrop, Gilliane and Richard know that nothing will ever stop them from risking it all for love, and giving all to desire."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “Mills is a sprightly storyteller, providing atmosphere and action aplenty, and cannily complicating her characters’ inner landscapes.” —"), _c('i', [_vm._v("Publishers Weekly")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Anita Mills\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Diversion Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0